module.exports = "/assets/c0710830316ae6b8a616c9d9817c328a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RX.png
// module id = 2923
// module chunks = 0